










































































































































import Vue from 'vue';
import Playlist from '@/lib/playlist';

export default Vue.extend({
  name: 'Playlist',
  model: {
    prop: 'playlist',
    event: 'change',
  },
  props: {
    playlist: Playlist,
  },
  data() {
    return {
      search: '',
      expanded: [],
      toDelete: null as number | null,
      confirmDelete: false,
      tableHeaders: [
        { value: 'title', text: 'Title' },
        { value: 'author', text: 'Author' },
        { value: 'delete' },
      ],
    };
  },
  computed: {
    name: {
      get(): string {
        return this.playlist.name;
      },
      set(name: string) {
        this.$emit('change', Object.assign(this.playlist, { name }));
      },
    },
  },
  methods: {
    deleteSelf() {
      if (this.confirmDelete) {
        this.$emit('delete');
      }
      this.confirmDelete = true;
    },
    deleteSong(id: number) {
      if (this.toDelete !== id) {
        this.toDelete = id;
        return;
      }
      this.toDelete = null;
      this.$emit('change', Object.assign(this.playlist, {
        songs: this.playlist.songs.filter((s) => s.id !== id),
      }));
    },
    updateSong(id: number, val: { title?: string; author?: string }) {
      Object.assign(this.playlist.songs[id], val);
      this.$emit('change', this.playlist);
    },
  },
});

